var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browser-notification"},[_c('div',[_c('emotion',{attrs:{"value":"cry"}})],1),_vm._v(" "),_c('h2',[_vm._v("对不起，当前系统版本太低")]),_vm._v(" "),_c('p',[_vm._v("请升级后再使用")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary","block":"","href":"https://support.apple.com/zh-cn/HT204204","target":"_blank"}},[_vm._v("如何升级系统？")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }